import React from "react";
import { CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const features = ["Fachgerechter Rückbau & Komplettentkernung", "Wanddurchbrüche & präzise Kernbohrungen", "Demontage von Einbauten, Böden & Decken", "Schnelle und umweltgerechte Schuttentsorgung"];
export default function ServicesGridVerputzarbeiten() {
  return <section id="services-grid-verputzarbeiten" className="bg-background py-12 md:py-16">
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="order-2 lg:order-1 rounded-lg overflow-hidden shadow-md">
            <AspectRatio ratio={4 / 3}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/steptodown.com823707.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/steptodown.com823707.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1675284/img/steptodown.com823707.png-wvc-sizes" alt="Verputzarbeiten" className="w-full h-full object-cover" loading="lazy" />
            </AspectRatio>
          </div>

          {}
          <div className="order-1 lg:order-2 flex flex-col gap-6">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground">Abbruch- &amp; Sanierungsarbeiten<div><br /></div></h2>
              <p className="text-lg text-muted-foreground">
                Wir schaffen Platz für Neues: Mit modernem Gerät und handwerklicher Präzision übernehmen wir fachgerechte Entkernungen, präzise Wanddurchbrüche und vorbereitende Rückbauarbeiten. Sauber, sicher und termingerecht für die perfekte Basis Ihres Projekts.
              </p>
            </div>

            <ul className="flex flex-col gap-3">
              {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="w-6 h-6 text-primary shrink-0 mt-0.5" />
                  <span className="text-foreground">{feature}</span>
                </li>)}
            </ul>

            <div className="pt-3">
              <Button asChild size="lg" className="w-full sm:w-auto">
                <Link to="/ServicesPage">Angebot anfordern</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}